import shouldBubbleEventToParentIframe from '../utils/shouldBubbleEventToParentPage.js';
import bubbleEventToParentIframe from '../utils/bubbleEventToParentPage.js';

function onZephrHistoryReplace(e) {
  if (shouldBubbleEventToParentIframe()) {
    return bubbleEventToParentIframe(e);
  }

  const {
    detail: { href },
  } = e;

  if (!href) {
    console.error(
      'Web.Zephr:Error: onZephrHistoryReplace event requires href argument.',
    );
  }

  const __LOCALHOST__ = location.hostname === 'localhost';
  const topPageHasReactRouterDomHistory = window?.__CNBC?.history;
  const error = !__LOCALHOST__ && !topPageHasReactRouterDomHistory;
  if (error) {
    return console.error(
      'Web.Zephr:Error: onZephrHistoryReplace event requires the top page to expose a history object at window.__CNBC.history.',
    );
  }

  const { pathname, search } = new URL(href);
  const relativeURL = pathname + search;

  const shouldUseNativeBrowserHistory =
    __LOCALHOST__ && !topPageHasReactRouterDomHistory;
  if (shouldUseNativeBrowserHistory) {
    return history.replaceState(history.state, null, relativeURL);
  }

  // Localhost requires fully qualified URL, non-localhost requires relative URL
  const url = __LOCALHOST__ ? href : relativeURL;

  return window.__CNBC.history.replace(url, {
    ...window.__CNBC.history.location.state,
  });
}

window.addEventListener('onzephrhistoryreplace', onZephrHistoryReplace);

export default onZephrHistoryReplace;
